import React, { useEffect } from 'react';
import { HELP_LIST, MESSAGE_LIST } from '@/const';
import moment from 'moment';
import { useSetState } from 'ahooks';
import { getWarehouseCode } from '@/utils';

import HeaderContainer from '../HeaderContainer';
import InboundBoard from '../InboundBoard';
import OutboundBoard from '../outboundBoard';
import EfficiencyBoard from '../EfficiencyBoard';
import PersonBoard from '../PersonBoard';
import TipCom from '../TipCom';
import TimerHeader from '@/components/Timer';

import styles from './index.module.scss';
import {
  getWarehouseTime,
  getOutWarehouseTime,
  getPopupArticles,
  setdontmind,
  getpeople,
  getcount,
} from './index.services';
import { State } from './index.inerface';
import { Button, Dialog, Radio } from '@fpxfd/next';
import { P } from '@antv/g2plot';
import $i18n from 'panda-i18n';

const BillboardCom = () => {
  const [state, setState] = useSetState({
    time: [],
    outTime: [],
    fullyCustomizedVisible: false,
    acrtleData: {
      title: '标题',
      time: '时间',
      content: '',
    },
    radios: false,
    peoplecount: 0,
    totalcount: 0,
  });

  useEffect(() => {
    getWarehouseTime({ warehouseCode: getWarehouseCode() }).then((res) => {
      const begin = res?.dayBeginTimestamp;
      const end = res?.dayEndTimestamp;
      setState({ time: [moment(begin).format('YYYY-MM-DD HH:mm:ss'), moment(end).format('YYYY-MM-DD HH:mm:ss')] });
    });
    getOutWarehouseTime({ warehouseCode: getWarehouseCode() }).then((res) => {
      const begin = res?.dayBeginTimestamp;
      const end = res?.dayEndTimestamp;
      setState({ outTime: [moment(begin).format('YYYY-MM-DD HH:mm:ss'), moment(end).format('YYYY-MM-DD HH:mm:ss')] });
    });
    if (window.localStorage.getItem('showacrtle') === '1') {
      getPopupArticles({}).then((res) => {
        if (res?.popupRequired !== false) {
          if (res?.article) {
            setState({ acrtleData: res?.article, fullyCustomizedVisible: true });
            // 获取阅读人数
            getpeople(res?.article?.articleId).then((resp) => {
              setState({ peoplecount: resp });
            });

            // 获取阅读人次
            getcount(res?.article?.articleId).then((resp) => {
              setState({ totalcount: resp });
            });
          }
        }
        window.localStorage.setItem('showacrtle', '2');
      });
    }
  }, []);

  const onCloseFullyCustomized = () => {
    if (state.radios) {
      setdontmind(state.acrtleData?.articleId).then((res) => {
        window.localStorage.setItem('showacrtle', '2');
      });
    }
    setState({ fullyCustomizedVisible: false });
  };

  const acriltitle = (
    <div className={styles.acriltitles}>
      <h3>{state.acrtleData.title}</h3>
      <p>
        {moment(state.acrtleData?.createTime).format('YYYY-MM-DD HH:ss:mm')}
        <span className={styles.spans}>
          {$i18n.get({ id: 'NumberOfReaders', dm: '阅读人数' })} : {state.peoplecount}
        </span>
        <span>
          {$i18n.get({ id: 'Readings', dm: '阅读人次' })} : {state.totalcount}
        </span>
      </p>
    </div>
  );

  return (
    <div className={styles.container}>
      <div style={{ boxSizing: 'border-box', paddingRight: '20px', minWidth: '1000px', width: '78%' }}>
        <HeaderContainer />
        <TimerHeader title={'UTC/GMT'} style={{ marginBottom: '12px' }} />
        <div className={styles.row}>
          <div className={styles.board}>
            <InboundBoard time={state.time} />
          </div>
          <div className={styles.board}>
            <OutboundBoard time={state.outTime} />
          </div>
        </div>

        <div className={styles.row}>
          <div className={styles.board}>
            <EfficiencyBoard />
          </div>
          <div className={styles.board}>
            <PersonBoard />
          </div>
        </div>
      </div>
      <div style={{ width: '22%', minWidth: '280px' }}>
        <TipCom datas={MESSAGE_LIST} name="QUESTION_AND_HELP" />
        <TipCom datas={HELP_LIST} name="MESSAGE_REMINDER" />
      </div>

      <Dialog
        data-i18n-ignore-content
        title={acriltitle}
        width={700}
        v2
        footer={
          <div className={styles.footerbtns}>
            <span>.</span>
            <Button type="primary" onClick={onCloseFullyCustomized}>
              {$i18n.get({ id: 'TERM.Confirm_R4AM1', dm: '我知道了' })}
            </Button>
            <Radio
              onChange={(val) => {
                setState({ radios: val });
              }}
            >
              {$i18n.get({ id: 'NoMoreReminders', dm: '不再提醒' })}
            </Radio>
          </div>
        }
        visible={state.fullyCustomizedVisible}
        onOk={onCloseFullyCustomized}
        onClose={onCloseFullyCustomized}
      >
        <div
          data-i18n-ignore-content
          dangerouslySetInnerHTML={{ __html: state.acrtleData?.content }}
          className={styles.contents}
        />
      </Dialog>
    </div>
  );
};

export default BillboardCom;
